import { render, staticRenderFns } from "./EditEventPriceModal.vue?vue&type=template&id=57ef55c6&scoped=true&"
import script from "./EditEventPriceModal.vue?vue&type=script&lang=ts&"
export * from "./EditEventPriceModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditEventPriceModal.vue?vue&type=style&index=0&id=57ef55c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ef55c6",
  null
  
)

export default component.exports